document.addEventListener("DOMContentLoaded", function() {
    
    function embedBaner(id, content) {
      var baner = document.getElementById(id);
      if (baner) {
        baner.innerHTML = content;
      }
    }

    embedBaner("baner1", `
       <div class="banner1Left">
          <img src="https://cdn.shopify.com/s/files/1/0574/1235/4203/files/baner1-high.png?v=1702029838">
       </div>
       <div class="banner1Right">
          <span class="baner-title">Baza na codzień</span>
          <span class="baner-subtitle">Kobieta · JA</span>
          <a href="/products/baza-na-co-dzien-ja-kobieta-18-49" class="button banner-button">Kup teraz</a>
       </div>
    `);
    embedBaner("baner2", `<div class="banner2Left">
          <img src="https://cdn.shopify.com/s/files/1/0574/1235/4203/files/baner2-high.png?v=1702029838">
       </div>
       <div class="banner2Right">
          <span class="baner-title">Baza na codzień</span>
          <span class="baner-subtitle">Kobieta · JA+</span>
          <a href="/products/baza-na-co-dzien-ja-plus-kobieta" class="button banner-button">Kup teraz</a>
       </div>`);
    embedBaner("baner3", `<div class="banner3Left">
          <img src="https://cdn.shopify.com/s/files/1/0574/1235/4203/files/baner3-high.png?v=1702029838">
       </div>
       <div class="banner3Right">
          <span class="baner-title">Baza na codzień</span>
          <span class="baner-subtitle">Dziecko · JA+</span>
          <a href="/products/baza-na-co-dzien-dziecko-ja" class="button banner-button">Kup teraz</a>
       </div>`);
    embedBaner("baner4", `<div class="banner4Left">
          <img src="https://cdn.shopify.com/s/files/1/0574/1235/4203/files/baner4-high.png?v=1702029837">
       </div>
       <div class="banner4Right">
          <span class="baner-title">Magnez + Witamina B6</span>
          <a href="/products/magnez-witaminab6" class="button banner-button">Kup teraz</a>
       </div>`);
    embedBaner("baner5", `<div class="banner5Left">
          <img src="https://cdn.shopify.com/s/files/1/0574/1235/4203/files/baner5-high.png?v=1702029837">
       </div>
       <div class="banner5Right">
          <span class="baner-title">Witamina D3</span>
          <a href="/products/witamina-d3" class="button banner-button">Kup teraz</a>
       </div>`);
    embedBaner("baner6", `<div class="banner6Left">
          <img src="https://cdn.shopify.com/s/files/1/0574/1235/4203/files/baner6-high.png?v=1702029837">
       </div>
       <div class="banner6Right">
          <span class="baner-title">Baza na co dzień</span>
          <span class="baner-subtitle">Kobieta · JA · JA+</span>
          <a href="/collections/suplementy-diety" class="button banner-button">Kup teraz</a>
       </div>`);
    embedBaner("baner7", `<div class="banner7Left">
          <img src="https://cdn.shopify.com/s/files/1/0574/1235/4203/files/baner7-high.png?v=1702029837">
       </div>
       <div class="banner7Right">
          <div class="banerIcon"><span class="baner-icon"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.5" cy="9.5" r="9.5" fill="#34B78F"/>
            </svg>
            </span><span class="baner-title-icon">Magnez + Witamina B6</span></div>
          <div class="banerIcon"><span class="baner-icon"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.5" cy="9.5" r="9.5" fill="#34B78F"/>
            </svg>
            </span><span class="baner-title-icon">Witamina D3</span></div>
          <a href="/collections/linia-wspierajaca" class="button banner-button">Kup teraz</a>
       </div>`);
    embedBaner("baner8", `<div class="banner8Left">
          <img src="https://cdn.shopify.com/s/files/1/0574/1235/4203/files/baner8-high.png?v=1702029838">
       </div>
       <div class="banner8Right">
          <div class="banerIcon" style="align-items: baseline;"><span class="baner-icon"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.5" cy="9.5" r="9.5" fill="#ECF166"/>
            </svg>
            </span><div class="banner-title-wrap"><span class="baner-title-icon">Baza na co dzień</span><span class="baner-subtitle-icon">Kobieta · JA</span></div></div>
          <div class="banerIcon"><span class="baner-icon"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.5" cy="9.5" r="9.5" fill="#ECF166"/>
            </svg>
            </span><span class="baner-title-icon">Magnez + Witamina B6</span></div>
          <a href="/collections/suplementy-diety" class="button banner-button">Kup teraz</a>
       </div>`);
    embedBaner("baner9", `<div class="banner9Left">
          <img src="https://cdn.shopify.com/s/files/1/0574/1235/4203/files/baner9-high.png?v=1702027977">
       </div>
       <div class="banner9Right">
          <div class="banerIcon" style="align-items: baseline;"><span class="baner-icon"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.5" cy="9.5" r="9.5" fill="#ECF166"/>
            </svg>
            </span><div class="banner-title-wrap"><span class="baner-title-icon">Baza na co dzień</span><span class="baner-subtitle-icon">Kobieta · JA+</span></div></div>
          <div class="banerIcon"><span class="baner-icon"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.5" cy="9.5" r="9.5" fill="#ECF166"/>
            </svg>
            </span><span class="baner-title-icon">Magnez + Witamina B6</span></div>
          <a href="/collections/suplementy-diety" class="button banner-button">Kup teraz</a>
       </div>`);
  });